import { useCallback, useState } from "react";

type useInputStateProps<T> = {
  value?: T;
  defaultValue?: T;
  onChange?: (value: T) => void;
};

export function useInputState<T>({
  value,
  defaultValue,
  onChange,
}: useInputStateProps<T>) {
  const isControlled = value !== undefined;

  const [internalValue, setInternalValue] = useState<T | undefined>(
    defaultValue
  );

  const currentValue = isControlled ? value : internalValue;

  const setValue = useCallback(
    (next: T) => {
      if (!isControlled) {
        setInternalValue(next);
      }
      onChange?.(next);
    },
    [isControlled, onChange]
  );

  return [currentValue, setValue] as const;
}